import stringify from './stableStringify';

export default {
    groupBy: function (array, key) {
        if (!array || !Array.isArray(array)) return {};
        return array.reduce((acc, obj) => {
            const value = obj[key];
            if (!acc[value]) acc[value] = [];
            acc[value].push(obj);
            return acc;
        }, {});
    },
    // AntArray.js - Hàm distinct sau khi sửa
    distinct: function (array, key) {
        if (!array || !Array.isArray(array) || array.length === 0) return [];

        if (key) {
            const seen = new Set();
            const result = [];
            for (const item of array) {
                const val = item && typeof item === 'object' ? item[key] : null;
                if (!seen.has(val)) {
                    seen.add(val);
                    result.push(val);
                }
            }
            return result;
        }
        return Array.from(new Set(array));
    },

    distinctWithSum: function (array, distinctKey, sumKey) {
        if (!array || !Array.isArray(array)) return [];

        const sums = new Map();
        for (const item of array) {
            const key = item[distinctKey];
            const val = parseFloat(item[sumKey] || 0);
            if (!isNaN(val)) {
                sums.set(key, (sums.get(key) || 0) + val);
            }
        }
        return Array.from(sums.entries()).map(([k, v]) => ({ key: k, value: v }));
    },
    someInnerJoin: function (array1, array2) {
        if (!array1 || !array2 || !Array.isArray(array1) || !Array.isArray(array2)) return false;
        const set = new Set(array2);
        return array1.some((a1) => set.has(a1));
    },

    combinations: function (array, size) {
        if (!array) return [];
        const result = [];

        // Mode 1: Specific size (nCk). Matches legacy logic: if (num) ...
        // Legacy treats 0 as falsy (!num), so only strictly positive size triggers nCk mode.
        if (typeof size === 'number' && size > 0) {
            function backtrack(start, current) {
                if (current.length === size) {
                    result.push([...current]);
                    return;
                }
                for (let i = start; i < array.length; i++) {
                    current.push(array[i]);
                    backtrack(i + 1, current);
                    current.pop();
                }
            }
            backtrack(0, []);
            return result;
        }

        // Mode 2: Power Set (All subsets) - Triggered if size is 0, null, or undefined
        // Legacy logic (!num) implies returning all subsets.
        // Legacy recursively excluded the empty set implicitly.

        result.push([]);
        for (let i = 0; i < array.length; i++) {
            const len = result.length;
            for (let j = 0; j < len; j++) {
                result.push([...result[j], array[i]]);
            }
        }
        // Remove the empty set [] (first element) to match legacy behavior
        return result.slice(1);
    },

    parse(value, test) {
        if (value === undefined || String(value).trim() === 'undefined') return [];
        if (value === null || String(value).trim() === 'null' || String(value).trim() === '') return [];

        if (value instanceof Array) return this.distinct(value.flat()).sort();

        if (JSON.parse(stringify(value)) instanceof Array) return this.distinct(JSON.parse(stringify(value)).flat()).sort();

        let newValue = String(value);
        if (newValue.startsWith('"')) newValue = newValue.slice(1, -1);
        if (newValue.startsWith("'")) newValue = newValue.slice(1, -1);

        if (!newValue.includes('[') && !newValue.includes(']') && !newValue.includes(',')) {
            return [newValue];
        }

        try {
            if (newValue.includes('[')) newValue = newValue.replace('[', '');
            if (newValue.includes(']')) newValue = newValue.replace(']', '');

            newValue = newValue
                .split(',')
                .map((s) => {
                    if (s.startsWith('"')) s = s.slice(1, -1);
                    if (s.startsWith("'")) s = s.slice(1, -1);
                    return s.trim();
                })
                .filter((s) => s !== '');

            newValue = this.distinct(newValue.flat()).sort();

            return newValue;
        } catch (error) {
            console.log('ant-log-Array-parse-failed: ', value);
        }

        return value;
    }
};
